<template>
  <div class="fond">
    <img src="../assets/IMG/fondo.webp" width="100%" class="desktop-img" />
    <img src="../assets/IMG/movil_welcome.webp" width="100%" class="mobile-img" />
    <div class="text-overlay">
      <h2 class="font-astron">BIENVENIDO A</h2>
      <h1 class="font-astron">MY CARD</h1>
      <h4 class="font-astron">Seguridad, innovación y profesionalismo.</h4>
    </div>
  </div>
</template>

<script>
export default { name: "WelcomeView" };
</script>

<style scoped>

.fond {
  position: relative;
  margin: 0;
  padding: 0;
}

.desktop-img {
  display: block;
  width: 100%;
}

.mobile-img {
  display: none;
  width: 100%;
}

.text-overlay {
  position:absolute;
  top: 47%;
  left: 10%;
  transform: translateY(-50%);
  text-align: left;
}

.text-overlay h1 {
  color: #ffffff;
  font-family: "Trial", sans-serif;
  font-size: 7.8vw;
  font-weight: 700;
  margin: 0 0 -5px 0;
  line-height: 1;
}

.text-overlay h2 {
  color: #ffffff;
  font-family: "TT Chocolates", sans-serif;
  font-size: 5vw;
  font-weight: 200;
  margin: 0 0 -5px 0;
  letter-spacing: 0.07em;
  line-height: 1;
}

.text-overlay h4 {
  font-family: "TT Chocolates", sans-serif;
  color: #ffffff;
  font-weight: 200;
  margin: 0;
  font-size: 2vw;
  line-height: 1;
}

@media (max-width: 768px) {
  .desktop-img {
    display: none;
  }

  .mobile-img {
    display: block;
  }

  .text-overlay {
    top: auto;
    bottom: 25%;
    left: 8%;
    transform: none;
    text-align: left;
    width: 90%;
  }

  .text-overlay h1 {
    font-size: 14vw;
  }

  .text-overlay h2 {
    font-size: 8.5vw;
  }

  .text-overlay h4 {
    font-size: 4.3vw;
  }
}

@media (max-width: 480px) {
  .desktop-img {
    display: none;
  }

  .mobile-img {
    display: block;
  }

  .text-overlay {
    top: auto;
    bottom: 22%;
    left: 8%;
    transform: none;
    text-align: left;
    width: 90%;
  }

  .text-overlay h1 {
    font-size: 15vw;
  }

  .text-overlay h2 {
    font-size: 9vw;
  }

  .text-overlay h4 {
    font-size: 4.5vw;
  }
}
</style>
